const propsWithout = (props, propsToRemove: string[]) => Object.keys(props)
    .filter((key) => propsToRemove.indexOf(key) !== -1)
    // eslint-disable-next-line array-callback-return
    .reduce((retVal, key) => {
        // eslint-disable-next-line no-param-reassign
        retVal[key] = props[key];
    }, {} as any);

export { propsWithout };
